var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5000,
    height: 5001,
    className: "logo_loader",
    viewBox: "0 0 5000 5001",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M908.863 4429.01C912.409 4431.96 915.068 4434.03 916.841 4435.51C1518.41 4926.87 2339.52 5131.34 3147.03 4915.05C4192.98 4634.95 4905.36 3731.12 4991.63 2710.87C4992.52 2701.41 4993.41 2687.52 4994.88 2668.91C4884.97 2578.2 4795.15 2545.4 4725.71 2570.22C2930.16 3210.5 1657.87 3830.1 908.863 4429.01Z",
    fill: "#4A3BE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M909.152 4428.42C912.698 4431.38 915.357 4433.44 917.13 4434.92C1518.7 4926.28 2339.81 5130.75 3147.02 4914.46C4192.98 4634.36 4905.35 3730.53 4991.63 2710.28C4992.51 2700.82 4993.4 2686.94 4994.88 2668.32C4884.96 2577.91 4795.14 2544.82 4725.71 2569.63C2930.45 3209.62 1658.16 3829.21 909.152 4428.42Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4750.52 3588.7C4757.32 3574.81 4762.05 3564.47 4765.3 3557.38C5309.25 2394.72 4882.01 989.178 3749.48 335.308C2811.67 -205.988 1668.8 -70.9594 886.399 589.41C879.308 595.32 868.671 604.479 854.488 616.889C855.375 771.714 889.058 864.786 955.834 896.401C2402.74 1583.07 3534.67 2051.38 4039.92 2436.97C4580.33 2849.15 4817.3 3232.96 4750.52 3588.7Z",
    fill: "#B71E5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4750.52 3588.7C4757.32 3574.81 4762.05 3564.47 4765.3 3557.38C5309.25 2394.72 4882.01 989.178 3749.48 335.308C2811.67 -205.988 1668.8 -70.9594 886.399 589.41C879.308 595.32 868.671 604.479 854.488 616.889C855.375 771.714 889.058 864.786 955.834 896.401C2402.74 1583.07 3534.67 2051.38 4039.92 2436.97C4580.33 2849.15 4817.3 3232.96 4750.52 3588.7Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2316.76 7.04333C2301.4 8.2252 2289.87 9.11159 2282.49 9.70252C1003.7 119.912 0 1193.05 0 2500.49C0 3583.38 688.439 4505.54 1651.66 4852.71C1660.53 4855.96 1673.53 4860.39 1691.26 4866.6C1537.91 3088.47 1504.82 1862.28 1591.68 1188.32C1677.96 514.656 1919.95 120.798 2316.76 7.04333Z",
    fill: "#F15522"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2316.76 7.04333C2301.4 8.2252 2289.87 9.11159 2282.49 9.70252C1003.7 119.912 0 1193.05 0 2500.49C0 3583.38 688.439 4505.54 1651.66 4852.71C1660.53 4855.96 1673.53 4860.39 1691.26 4866.6C1537.91 3088.47 1504.82 1862.28 1591.68 1188.32C1677.96 514.656 1919.95 120.798 2316.76 7.04333Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M908.863 4429.01C912.409 4431.97 915.068 4434.03 916.841 4435.51C1183.65 4653.27 1493.3 4814.6 1825.99 4908.26C1829.84 4909.15 1835.15 4910.92 1842.84 4912.99L1715.78 3889.19C1709.88 3892.74 1705.15 3895.4 1702.19 3897.17C1495.66 4016.54 1231.22 4193.82 908.863 4429.01Z",
    fill: "#4A3BE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2737.7,
    y1: 4272.11,
    x2: 5797.45,
    y2: 2368.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 3170.44,
    y1: 1539.74,
    x2: -977.086,
    y2: -11.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B71E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1503.35,
    y1: 2476.29,
    x2: 2761.8,
    y2: 6176.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.6f97a8d7.svg";
export { ForwardRef as ReactComponent };